import { render, staticRenderFns } from "./CardsSelector.vue?vue&type=template&id=4a752550&"
import script from "./CardsSelector.vue?vue&type=script&lang=js&"
export * from "./CardsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports